module.exports = __webpack_public_path__ + "img/kh.639f7b8c.svg";